import { DropDown, Modal } from "@aqar-app/react-ui";
import {
  CATEGORIES_HAS_STATS_DICTIONARY,
  CITIES_HAS_STATS_DICTIONARY,
} from "../../../common/constants";
import { usePath } from "../../../contexts/path/path";
import StatsTable from "./StatsTable/statsTable";
import css from "./.module.scss";
import { Icon } from "@/components/icon";

const StatsButton = () => {
  const { category, city, district } = usePath();
  return CATEGORIES_HAS_STATS_DICTIONARY[category?.id] &&
    CITIES_HAS_STATS_DICTIONARY[city.id] ? (
    <DropDown
      overlay={
        <Modal.ClassicOverlay className={css.statsOverlay}>
          <StatsTable
            category={category.id}
            cityId={city.id}
            districtName={district.name?.replace(/حي /g, "")}
            districtId={district.id}
          />
        </Modal.ClassicOverlay>
      }
    >
      <button type="button" className={css.statsButton}>
        <span className={css.label}>أسعار الحي</span>
        <Icon width={15} height={15} name="statsBtn" className={css.icon} />
      </button>
    </DropDown>
  ) : null;
};

export default StatsButton;
